import React, { Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { api, useResource } from 'app';
import Form, { Errors, Submit, TextInput } from 'packages/form';
import { Container } from 'components/Page';
import { useUserContext } from 'app/user';
import SuccessModal from './SuccessModal';

const inputPropsByChannelType = {
  email: {
    label: 'ایمیل',
    placeholder: 'example@gmail.com'
  },
  sms: {
    label: 'شماره موبایل',
    placeholder: '09xxxxxxxxx'
  }
};

function TestCampaignForm({ campaignId, defaultContactInfo = '', setDefaultContactInfo }) {
  const campaign = useResource('campaign', 'single', `/advertising-campaigns/${campaignId}`);
  const user = useUserContext();
  let contactInfo = defaultContactInfo;
  const campaignData = campaign.body.data;
  const [status, setStatus] = useState('none');

  const handleClose = () => {
    setStatus('none');
  };

  if (contactInfo.length === 0 && campaignData.channel === 'email' && user.email) {
    contactInfo = user.email;
  } else if (contactInfo.length === 0 && campaignData.channel === 'sms' && user.mobile) {
    contactInfo = user.mobile;
  }

  const handleSubmit = data => {
    setDefaultContactInfo(data['contact_info']);
    return api
      .post(`/advertising-campaigns/${campaignData.id}/test`, data)
      .then(setStatus('submitSucceeded'));
  };

  return [
    <Form
      key="testCampaign"
      name="testCampaign"
      initialValues={{ contact_info: contactInfo }}
      onSubmit={handleSubmit}
    >
      <Errors />

      <TextInput
        name="contact_info"
        textDirection="ltr"
        {...inputPropsByChannelType[campaignData.channel]}
      />

      <Submit text="ارسال تست" />
    </Form>,
    <SuccessModal key="SuccessModal" show={status === 'submitSucceeded'} onHide={handleClose} />
  ];
}

function TestCampaign({ campaignId }) {
  const [contactInfo, setContactInfo] = useState('');

  const setDefaultContactInfo = data => {
    setContactInfo(data);
  };

  return (
    <Suspense fallback={'...'}>
      <Container size="small">
        <TestCampaignForm
          campaignId={campaignId}
          defaultContactInfo={contactInfo}
          setDefaultContactInfo={setDefaultContactInfo}
        />
      </Container>
    </Suspense>
  );
}

TestCampaign.propTypes = {
  campaignId: PropTypes.number.isRequired
};

export default TestCampaign;
